/**
 * <ia-collection-menu>
 *
 * Mobile dropdown for the IA Collection Menu section. Only present when the
 * section's "Render as dropdown on mobile" setting is enabled. The desktop
 * scroll row and the dropdown are both rendered server-side; CSS swaps which
 * one is visible per breakpoint. This element only wires up the dropdown's
 * open/close behaviour.
 */
class IaCollectionMenu extends HTMLElement {
  constructor() {
    super();

    this.dropdown = this.querySelector('.ia-collection-menu__dropdown');
    this.toggle = this.querySelector('.ia-collection-menu__dropdown-toggle');
    this.panel = this.querySelector('.ia-collection-menu__dropdown-panel');

    if (!this.dropdown || !this.toggle || !this.panel) return;

    this.onToggle = this.onToggle.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  get isOpen() {
    return this.dropdown.classList.contains('is-open');
  }

  open() {
    this.dropdown.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.panel.removeAttribute('hidden');
  }

  close() {
    this.dropdown.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('hidden', '');
  }

  onToggle(event) {
    event.stopPropagation();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  onDocumentClick(event) {
    if (!this.dropdown.contains(event.target)) this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}

if (!customElements.get('ia-collection-menu')) {
  customElements.define('ia-collection-menu', IaCollectionMenu);
}
